export default {
    data() {
        return {
            columns: [
                {
                    title: $t('labelTitle.Range'),
                    index: 'sceneName',
                    icon: [
                        {
                            type: 'userType',
                            index: 'sign',
                            default: 0,
                            power: ['isSysAdmin', 'isSysNoAdmin']
                        }
                    ],
                    power: ['isSysAdmin', 'isSysNoAdmin']
                },
                {
                    title: this.$t('public.table_name'),
                    icon: [
                        {
                            type: 'userType',
                            index: 'sign',
                            default: 0
                        }
                    ],
                    index: 'name'
                },
                {
                    title: this.$t('integration.phone_number'),
                    index: 'phone'
                },
                {
                    title: $t('public.emailbox'),
                    index: 'email'
                },
                {
                    title: $t('public.table_operation'),
                    width: 120,
                    operation: [
                        {
                            type: 'detail',
                            click: this.detailRow
                        },
                        {
                            type: 'delete',
                            // tip:{
                            //     content:this.$t('messageTitle.DeleteToContinue')
                            // },
                            show: {
                                index: 'sign',
                                value: 0
                            },
                            click: row => {
                                return this.TODOTIPDEL([row.id]);
                            }
                        }
                    ]
                }
            ]
        };
    }
};
